import styled from '@emotion/styled';
import React from 'react';

import { DesignToken } from '~/client/components/base/core';
import Arranger from '~c/components/base/arranger';
import PieGraph, { GraphDatum } from '~c/components/base/graph-card';
import Spacer, { spc } from '~c/components/base/spacer';

interface Props {
  className?: string;
}

const data: GraphDatum[] = [
  {
    id: 'Low',
    label: '15 Low',
    value: 15,
    color: DesignToken.status.info,
  },
  {
    id: 'Med',
    label: '5 Med',
    value: 5,
    color: DesignToken.status.danger,
  },
  {
    id: 'High',
    label: '3 High',
    value: 3,
    color: DesignToken.status.warning,
  },
];

const PieGraphDemo: React.FC<Props> = ({ className }) => {
  return (
    <Arranger className={className} shouldWrap>
      <PieGraph
        data={data}
        title="Projects Risk Overview"
        donutOpt={{
          title: '17',
          description: 'Non Compliant',
        }}
      />
      <Spacer pr={spc.xs} />
      <PieGraph
        data={data}
        title="Projects Risk Overview"
        colors={[
          DesignToken.status.info,
          DesignToken.status.warning,
          DesignToken.status.danger,
        ]}
      />
    </Arranger>
  );
};

export default styled(PieGraphDemo)`
  display: flex;
`;
